function updateGooxitFreeShipping() {

  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {

      const goal = window.gooxitSettings.goal;
      const cartTotal = cart.total_price / 100;

      const remaining = Math.max(goal - cartTotal, 0);
      const progress = Math.min((cartTotal / goal) * 100, 100);

      const message = document.getElementById('gooxit-free-shipping-message');
      const fill = document.getElementById('gooxit-progress-fill');

      if (!message || !fill) return;

      fill.style.width = progress + "%";

      if (cartTotal >= goal) {

        message.innerHTML =
          "🎉 Congratulations! You unlocked <strong>FREE</strong> shipping.";

      } else {

        message.innerHTML =
          "✨ You're just <strong>₹" +
          remaining.toLocaleString('en-IN') +
          "</strong> away from <strong>FREE</strong> shipping.";

      }

    });

}

document.addEventListener("DOMContentLoaded", updateGooxitFreeShipping);